import { idVideoDinUrl } from '@/domains/auth/utils/youtube-player';
import { YoutubeFacade } from '@/shared/components/YoutubeFacade';

/**
 * Videoclipul-disclaimer despre colectarea bateriilor in scoala, pe ecranul
 * «Comandă recipiente DBA» (cerut de ECOTIC, 2026-09-21).
 *
 * Playerul propriu-zis e `YoutubeFacade` (fatada click-to-play, extrasa de
 * aici in `shared/components/`) — fara autoplay la deschiderea paginii — pe
 * mobil oricum nu porneste, iar un video care porneste singur peste un formular
 * e agresiv. `end={72}` opreste clipul la 1:12, unde se termina partea
 * relevanta pentru comanda.
 *
 * `youtube-nocookie.com`, ca in `VideoIntroPage.tsx`: produs pentru scoli.
 */

const URL_VIDEO = 'https://www.youtube.com/watch?v=GXI8_Qehg9I';
const TITLU = 'Colectarea bateriilor uzate în școală';

export function VideoColectareBaterii() {
    const idVideo = idVideoDinUrl(URL_VIDEO);

    if (!idVideo) return null;

    return (
        <section
            data-video-colectare
            className="rounded-lg border border-hairline bg-white p-4"
            aria-labelledby="titlu-video-colectare"
        >
            <h2 id="titlu-video-colectare" className="m-0 font-semibold text-dark">
                Înainte să comandați
            </h2>
            <div className="mt-3">
                <YoutubeFacade videoId={idVideo} end={72} titlu={TITLU} />
            </div>
            <p className="m-0 mt-2 text-small text-gray-600">{TITLU}</p>
        </section>
    );
}
